<script setup lang="ts">
  // ヘッダーのソートメニュー
  // このコンポーネントは、ヘッダーのソートメニューを表示します
  import { type SortOrderType } from "~/stores/FilterStore";

  interface Props {
    sortOrder: SortOrderType;
    selectedValue: string;
    sortItems: { title: string; value: string }[];
    isTest?: boolean;
  }

  const localProps = defineProps<Props>();

  interface Emits {
    (event: "changeSort", value: string): void;
  }
  const emit = defineEmits<Emits>();

  const changeSort = (value: string) => {
    emit("changeSort", value);
  };

  const getTitleColor = (value: string) => {
    return value === localProps.selectedValue ? "text-blue" : "text-white";
  };

  const getOrderColor = (value: string, order: string) => {
    if (value === localProps.selectedValue && order === localProps.sortOrder) {
      return "blue";
    }
    return "white";
  };
</script>

<template>
  <!-- ソート -->
  <v-menu scroll-strategy="close" :attach="!!isTest">
    <template #activator="{ props }">
      <v-icon v-bind="props" :size="28" icon="$mdiSortVariant" data-testid="sort-icon" />
    </template>
    <v-sheet class="popup">
      <div class="popup-list">
        <div
          v-for="(item, i) in sortItems"
          :key="item.value"
          class="popup-list-item"
          :data-testid="`sort-item-${i + 1}`"
          @click="changeSort(item.value)"
        >
          <div class="pl-2 pr-0" :class="getTitleColor(item.value)">
            {{ item.title }}
          </div>
          <div class="sortable">
            <v-icon :color="getOrderColor(item.value, 'asc')" icon="$mdiTriangleSmallUp" :size="24" class="up" />
            <v-icon :color="getOrderColor(item.value, 'desc')" icon="$mdiTriangleSmallDown" :size="24" class="down" />
          </div>
        </div>
      </div>
    </v-sheet>
  </v-menu>
</template>

<style lang="scss" scoped>
  .popup {
    background-color: rgb(var(--v-theme-monochrome-04)) !important;
  }
  .popup-list {
    padding: 8px 0;
  }
  .popup-list-item {
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    &:hover {
      background-color: rgb(var(--v-theme-monochrome-05));
    }
  }
  .sortable {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
    .up,
    .down {
      position: absolute;
      top: 0;
      left: 0;
    }
    .up {
      top: -3px;
    }
    .down {
      top: 6px;
    }
  }
</style>
